module.exports = __webpack_public_path__ + "static/img/znzz2.7ed5bab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/znzz2.jpg
// module id = DWTh
// module chunks = 0